import React, { Fragment } from "react";
import {
  BudgetSectionContainer,
  Title,
  Section,
  Description,
  Amount,
  Date,
  TitleWithOptions,
  BillingDetailsContainer,
  BillingDetailsValue
} from "./BudgetSectionStyles";
import { Field } from "redux-form";
import FilesInput from "../inputs/FilesInput";
import { ExtraPill, FileSection, ResponsePill } from "../inputs/InputStyles";
import { Icon, Popconfirm } from "antd";
import Dropzone from "react-dropzone";
import FileInput from "../inputs/FileInput";
import { OptionButton } from "../../pages/budget/BudgetStyles";
import { numberFormat } from "../../infra/services/utils/FormatNumber";

const BudgetSection = ({ title, section, text, amount, date, type, document, translate, onDelete, onOpenView, billing, mainColor, phaseConcluded, budget }) => {
  if (type === 'PAYMENT' && phaseConcluded) {
    mainColor = '#fff';
  }
  
  return (
    <Fragment>
      <BudgetSectionContainer style={{backgroundColor: mainColor}}>
        {
          title && type != 'PAYMENT_PROOF' && <Title>{title}</Title>
        }
        {
          billing && billing?.fullName && billing?.identificationNumber && type === 'PAYMENT_PROOF' && <TitleWithOptions>
            <Title>{billing?.fullName} - {billing?.identificationNumber}</Title>
            <Icon type="eye" onClick={onOpenView}/>
            {/* <Popconfirm
              title={translate('CONFIRM_PAYMENT_PROOF_REMOVE')}
              onConfirm={onDelete}>
              <Icon type="delete" />
            </Popconfirm> */}
            </TitleWithOptions>
        }
        {
          section && <Section>{section}</Section>
        }
        {
          text && <Description dangerouslySetInnerHTML={{ __html: text }} />
        }
        {
          amount && type != 'PAYMENT_PROOF' && <Amount>{amount}</Amount>
        }
        {
          type === 'PAYMENT_PROOF' && <FileInput translate={translate} filePreview={true} addFile={false} input={{ value: document, onChange: null }}></FileInput>
        }
        {
          type === 'PAYMENT_PROOF' && ((budget?.billingValue && budget?.billingValue > 0) || budget?.billingLanguage) && <BillingDetailsContainer>
            <div style={{ padding: '4px' }}>
              {(budget?.billingValue && budget?.billingValue > 0) ? <BillingDetailsValue><b>{translate('BILLING_VALUE')}:</b> {numberFormat(budget.billingValue, 2)}€</BillingDetailsValue> : ''}
              {/* {budget?.billingLanguage ? <BillingDetailsValue><b>{translate('BILLING_LANGUAGE')}:</b> {budget.billingLanguage === 'pt' ? translate('LANG_PT') : budget.billingLanguage === 'en' ? translate('LANG_EN') : ''}</BillingDetailsValue> : ''} */}
            </div>
          </BillingDetailsContainer>
        }
        {
          date && <Date>{date}</Date>
        }
      </BudgetSectionContainer>
    </Fragment>
  );
}

export default BudgetSection;